// extracted by mini-css-extract-plugin
export default {"container":"VaultAbout-module__container--mnODD","vaultDescription":"VaultAbout-module__vaultDescription--QS650","curatorMainInfo":"VaultAbout-module__curatorMainInfo--wVQEI"};